import { render, staticRenderFns } from "./CustomerManufacturerDiscountInfo.vue?vue&type=template&id=2d6554da&"
import script from "./CustomerManufacturerDiscountInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerManufacturerDiscountInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports